module.exports = __webpack_public_path__ + "img/logo_text.6338a097.jpg";